import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/services/data.service';
import { ProjectManagementService } from "../../services/project-management.service";

@Component({
    selector: 'app-project-details-tab',
    templateUrl: './project-details-tab.component.html',
    styleUrls: ['./project-details-tab.component.scss']
})
export class ProjectDetailsTabComponent implements OnInit {

    selected_project = {};
    fieldNames = {};
    showMorePriorityDate = false;
    projectDetailsLoading = false;

    constructor(
        public dataService: DataService,
        private project_service: ProjectManagementService,
    ) { }

    ngOnInit() {
        this.get_project_details(this.dataService.selected_project);
        this.wait_for_project_details();
    }

    wait_for_project_details() {
        const temp = this.dataService.get_array_details(
            this.dataService.project_list,
            "fip_id",
            this.dataService.selected_project
        );
        if (temp !== undefined) {
            if (temp['title'] !== undefined) {
                this.selected_project = temp;
            }
        }

        this.fieldNames = this.dataService.getFieldNamesBasedOnProjectType(this.selected_project['project_type']);
    }

    get_project_details(project_id) {
        this.projectDetailsLoading = true;
        this.project_service.get_project_details(project_id, (resp) => {
            if (resp.status) {
                const test_proj = this.dataService.get_array_details(this.dataService.project_list, "fip_id", resp.data.fip_id);

                if (test_proj !== undefined) {
                    for (const key in resp.data) {
                        test_proj[key] = resp.data[key];
                    }
                } else {
                    this.dataService.project_list.push(resp.data);
                }

                // sort array
                this.dataService.project_list = this.dataService.sort_this_by_date(
                    this.dataService.project_list,
                    "required_delivery_date"
                );

                this.wait_for_project_details();
            }

            this.projectDetailsLoading = false;
        });
    }
}
